var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.352 5.087C17.052 0 10.315-1.513 5.09 1.65.002 4.812-1.648 11.687 1.652 16.775l.275.412-1.1 4.125 4.125-1.1.413.275C7.152 21.45 9.077 22 11.002 22c2.063 0 4.125-.55 5.913-1.65 5.087-3.3 6.6-10.038 3.437-15.263zm-2.887 10.588c-.55.825-1.238 1.375-2.2 1.512-.55 0-1.238.275-3.988-.825-2.337-1.1-4.262-2.887-5.637-4.95-.825-.962-1.238-2.2-1.375-3.437 0-1.1.412-2.063 1.1-2.75.275-.275.55-.413.825-.413h.687c.275 0 .55 0 .688.55.275.688.962 2.338.962 2.475a.418.418 0 010 .55c.138.275 0 .55-.137.688-.138.137-.275.412-.413.55-.275.137-.412.412-.275.687.55.825 1.238 1.65 1.925 2.338.825.687 1.65 1.237 2.613 1.65.275.137.55.137.687-.138.138-.275.825-.962 1.1-1.237.275-.275.413-.275.688-.138l2.2 1.1c.275.138.55.275.687.413.138.412.138.962-.137 1.375z",
    fill: "currentcolor"
  })));
}

export default SvgWhatsapp;